import restapi from 'utils/restapi';
import { addLang } from 'utils/addLang';
import { baseErrorsHandlerDecorator } from 'redux/utils';

import {
  CREATE_MENU_LINK_SUCCESS,
  CREATE_MENU_LINK_ERROR,
  FETCH_MENU_LINKS_LIST,
  FETCH_MENU_LINKS_LIST_ERROR,
  CLEAR_FETCH_MENU_LINKS_LIST,
  CLEAR_CREATE_MENU_LINK,
  PATCH_MENU_LINK_SUCCESS,
  PATCH_MENU_LINK_ERROR,
  DELETE_MENU_LINK_SUCCESS,
  DELETE_MENU_LINK_ERROR,
  CLEAR_DELETE_MENU_LINK,
  PATCH_MENUS_ITEM_SUCCESS,
  PATCH_MENUS_ITEM_ERROR,
  CLEAR_PATCH_MENUS_ITEM,
  CREATE_MENUS_ITEM_SUCCESS,
  CREATE_MENUS_ITEM_ERROR,
  CLEAR_CREATE_MENUS_ITEM,
  DELETE_MENUS_ITEM_SUCCESS,
  DELETE_MENUS_iTEM_ERROR,
  CLEAR_DELETE_MENUS_ITEM,
  APPLY_MENU_LINK_DRAG,
  APPLY_MENU_LINK_DRAG_ERROR,
  CLEAR_MENU_LINK_DRAG,
  ADD_MENUS_IMAGES_SUCCESS,
  ADD_MENUS_IMAGES_ERROR,
  CLEAR_ADD_MENUS_IMAGES,
  DELETE_IMAGES_SUCCESS,
  DELETE_IMAGES_ERROR,
  CLEAR_DELETE_IMAGES,
} from 'redux/menu-links/types';

export const fetchMenuLinksList = () =>
  baseErrorsHandlerDecorator(
    FETCH_MENU_LINKS_LIST,
    FETCH_MENU_LINKS_LIST_ERROR,
    () => restapi.get(addLang('links/menus/')),
    false
  );

export const clearFetchMenuLinksList = () => (dispatch) => {
  dispatch({
    type: CLEAR_FETCH_MENU_LINKS_LIST,
  });
};

export const createMenuLink = (formData) => {
  return baseErrorsHandlerDecorator(
    CREATE_MENU_LINK_SUCCESS,
    CREATE_MENU_LINK_ERROR,
    () => restapi.post(addLang('links/menus/'), formData),
    false,
    true /* actionSucces */
  );
};

export const clearCreateMenuLink = () => (dispatch) => {
  dispatch({
    type: CLEAR_CREATE_MENU_LINK,
  });
};

export const patchMenuLink = (linkId, formData) =>
  baseErrorsHandlerDecorator(
    PATCH_MENU_LINK_SUCCESS,
    PATCH_MENU_LINK_ERROR,
    () => restapi.patch(addLang(`links/menus/${linkId}/`), formData),
    false,
    true /* actionSucces */
  );


export const deleteMenuLink = (linkId) =>
  baseErrorsHandlerDecorator(
    DELETE_MENU_LINK_SUCCESS,
    DELETE_MENU_LINK_ERROR,
    () => restapi.delete(addLang(`links/menus/${linkId}/`)),
    false,
    true /* actionSucces */
  );

export const clearDeleteMenuLink = () => (dispatch) => {
  dispatch({
    type: CLEAR_DELETE_MENU_LINK,
  });
};

export const changeMenusItem = (linkId, formData) =>
  baseErrorsHandlerDecorator(
    PATCH_MENUS_ITEM_SUCCESS,
    PATCH_MENUS_ITEM_ERROR,
    () => restapi.patch(addLang(`links/menus/item/${linkId}/`), formData),
    false,
    true /* actionSucces */
  );

export const clearPatchMenusItem = () => (dispatch) => {
  dispatch({
    type: CLEAR_PATCH_MENUS_ITEM,
  });
};

export const createMenusItem = (formData) =>
  baseErrorsHandlerDecorator(
    CREATE_MENUS_ITEM_SUCCESS,
    CREATE_MENUS_ITEM_ERROR,
    () => restapi.post(addLang('links/menus/item/'), formData),
    false,
    true /* actionSucces */
  );

export const clearCreateMenusItem = () => (dispatch) => {
  dispatch({
    type: CLEAR_CREATE_MENUS_ITEM,
  });
};

export const deleteMenusItem = itemId => baseErrorsHandlerDecorator(
  DELETE_MENUS_ITEM_SUCCESS,
  DELETE_MENUS_iTEM_ERROR,
  () => restapi.delete(addLang(`links/menus/item/${itemId}/`)),
  false,
  true /* actionSucces */,
);

export const clearDeleteMenusItem = () => dispatch => {
  dispatch({
    type: CLEAR_DELETE_MENUS_ITEM,
  });
};

export const applyMenuLinkDrag = formData => baseErrorsHandlerDecorator(
  APPLY_MENU_LINK_DRAG,
  APPLY_MENU_LINK_DRAG_ERROR,
  () => restapi.post(addLang('links/menus/ordering/'), formData),
  false,
  true /* actionSucces */,
);

export const clearMenuLinkDrag = () => dispatch => {
  dispatch({
    type: CLEAR_MENU_LINK_DRAG,
  });
};

// ADD IMAGES
export const addImagesToMenusItem = (menusId, formData) => baseErrorsHandlerDecorator(
  ADD_MENUS_IMAGES_SUCCESS,
  ADD_MENUS_IMAGES_ERROR,
  () => restapi.post(addLang(`links/menus/item/${menusId}/media/`), formData),
  false,
  true /* actionSucces */,
);

export const clearAddImagesToMenusItem = () => dispatch => {
  dispatch({
    type: CLEAR_ADD_MENUS_IMAGES,
  });
};

// DELETE IMAGE
export const deleteImageFromMenusItem = menusId => baseErrorsHandlerDecorator(
  DELETE_IMAGES_SUCCESS,
  DELETE_IMAGES_ERROR,
  () => restapi.delete(addLang(`links/menus/item/media/${menusId}/`)),
  false,
  true /* actionSucces */,
);

export const clearDeleteImageFromMenusItem = () => dispatch => {
  dispatch({
    type: CLEAR_DELETE_IMAGES,
  });
};